export const BOARD_PURCHASE_ORDER_NUMBER_MIN_LENGTH = 1;
export const BOARD_PURCHASE_ORDER_NUMBER_MAX_LENGTH = 100;
